module.exports = __webpack_public_path__ + "img/9.b4bd31b2.jpg";